<template>
  <section>
    <!--表单-->
    <div class="promotion-box promotion-customize">
      <img src="https://dealer2.autoimg.cn/dealerdfs/g27/M02/23/A0/autohomedealer__ChcCQFtVhCOAVn-gAAAeY5DEPM8612.png"
           class="tit-customize">
      <img src="https://dealer2.autoimg.cn/dealerdfs/g29/M09/20/BA/autohomedealer__wKgHG1tVhECAe-TGAAH47SVVhPU189.png"
           class="box-bg">
      <div class="box-con">
        <div class="price-customize"
             v-if="!showResult">
          <p class="price-customize-num">
            <span class="font62 mr10">2.00</span>
            <span class="font36">元</span>
          </p>
          <p class="price-customize-name">现金红包</p>
        </div>
        <a v-if="!showResult"
           href="javascript:;"
           v-on:click="pickRedPacket()"
           class="btn-customize">立即领取</a>
        <p class="txt-customize"
           v-if="showResult"
           v-html="resultText"></p>
        <!-- <p class="txt-customize">活动已结束！</p> -->
      </div>
      <div class="box-txt">
        <dl>
          <dt>1.</dt>
          <dd>汽车之家用户初次进行主账户绑定可获取红包；</dd>
        </dl>
        <dl>
          <dt>2.</dt>
          <dd>红包将领取至汽车之家钱包，开通后可提现，由于领取人数较多，可能有延迟，预计两小时内到账；</dd>
        </dl>
        <dl>
          <dt>3.</dt>
          <dd>同一ID用户最多可获得1个红包；</dd>
        </dl>
        <dl>
          <dt>4.</dt>
          <dd>同一身份证用户有多个ID仅可获得1个红包；</dd>
        </dl>
        <dl>
          <dt>5.</dt>
          <dd>每天前10000名新注册用户可领取新人红包；</dd>
        </dl>
        <dl>
          <dt>6.</dt>
          <dd>恶意注册账号，使用作弊程序等行为，一经发现，汽车之家有权取消该用户及其恶意注册的所有账号的奖励资格。</dd>
        </dl>
        <p>汽车之家保留在法律规定的范围内对上述规则进行解释的权利</p>
      </div>
    </div>
    <!--表单-->
    <social-dialog title="正在加载"
                   category="tips"
                   v-bind:show="dialogShow"></social-dialog>
  </section>
</template>
<script>
import SocialDialog from '../../../components/social-dialog.vue'
import subjectApi from '../../../api/subject'
export default {
  components: {
    SocialDialog
  },
  name: 'RedPacketHome',
  data: function () {
    return {
      dialogShow: false,
      showResult: false,
      resultText: '哎呀，你已经是老用户了，<br/>把机会留给别的小伙伴吧！'
    }
  },
  created () {
    var current = this
    // 校验红包是否发完
    this.redPacketComplete()
    if (window.localStorage['pickedRedPacket']) {
      current.pickRedPacket()
    }
  },
  methods: {
    pickRedPacket () {
      var current = this
      current.dialogShow = true
      let http = subjectApi.pickRedPacket()
      http.then(function (res) {
        current.dialogShow = false
        console.log(res)
        if (res === null) {
          const query = { returnUrl: '/redpacket' }
          current.$router.replace({ name: 'AccountNewLogin', query: query })
          return
        }
        if (res.data.returnCode === 0) {
          window.localStorage['pickedRedPacket'] = 1
          location.href = 'https://pay.autohome.com.cn/ucenter/login/ahsso.htm?return_url=https://pay.autohome.com.cn/site-wap/coupon/list.htm'
        } else if (res.data.returnCode === 501001) {
          current.showResult = true
          current.resultText = '今日红包已经领取完毕，<br/>明日要尽早领取哦~'
        } else if (res.data.returnCode === 501002) {
          const query = { returnUrl: '/redpacket' }
          current.$router.replace({ name: 'AccountNewLogin', query: query })
        } else if (res.data.returnCode === 501003) {
          window.localStorage['pickedRedPacket'] = 1
          current.showResult = true
          current.resultText = '哎呀，你已经是老用户了，<br/>把机会留给别的小伙伴吧！'
        } else if (res.data.returnCode === 501004) {
          window.localStorage['pickedRedPacket'] = 1
          current.showResult = true
          current.resultText = '您已领取过红包！'
        } else {
          current.showResult = true
          current.resultText = '网络异常，请重试！'
        }
      })
    },
    redPacketComplete (isRedirect) {
      var current = this
      current.dialogShow = true
      let http = subjectApi.redPacketComplete()
      http.then(function (res) {
        current.dialogShow = false
        if (res.data.returnCode === 501001) {
          current.showResult = true
          current.resultText = '今日红包已经领取完毕，<br/>明日要尽早领取哦~'
        }
      })
    },
    changeRem () {
      document.getElementsByTagName('html')[0].style.fontSize = document.documentElement.clientWidth / 20 + 'px'     // 字体以16像素为基础
    }
  },
  mounted () {
    var current = this
    current.changeRem()
    let t
    window.addEventListener('resize', () => {
      clearTimeout(t)
      t = setTimeout(current.changeRem, 300)
    }, false)
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) {
        clearTimeout(t)
        t = setTimeout(current.changeRem, 300)
      }
    }, false)
  }
}
</script>
<style>
.promotion-box {
  position: relative;
  background-color: #d5262d;
  font-size: 0.8rem;
}
/* .promotion-box *{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;font-style:normal} */
.promotion-box .box-bg {
  position: relative;
  width: 100%;
}
.promotion-box .box-get {
  position: absolute;
  top: 23.35rem;
  width: 12.2rem;
  margin: 0 auto;
  left: 0;
  right: 0;
}
.promotion-box .box-get input {
  height: 1.2rem;
  line-height: 1.2rem;
  padding: 0.55rem 0 0.55rem 1.95rem;
  font-size: 0.8rem;
  border-radius: 2.45rem 0 0 2.45rem;
  border: 0.05rem solid #e99e4b;
  width: 7.85rem;
}
.promotion-box .box-get .box-btn {
  position: absolute;
  right: 0;
  top: -0.375rem;
  height: 2.975rem;
  width: 2.975rem;
  border-radius: 100%;
  border: 0.05rem solid #fc283f;
  background-image: -webkit-linear-gradient(to bottom, #fff, #f79c4d);
  background-image: -webkit-linear-gradient(top, #fff, #f79c4d);
  background-image: linear-gradient(to bottom, #fff, #f79c4d);
}
.promotion-box .box-get .box-btn span {
  display: block;
  margin: 0.2rem;
  height: 2.075rem;
  width: 2.075rem;
  background-color: #fc283f;
  border-radius: 50%;
  color: #fff;
  line-height: 1.05rem;
  padding: 0.25rem 0.25rem;
  text-align: center;
}
.promotion-box .box-txt {
  position: relative;
  padding: 0 1rem;
  color: #fff;
  line-height: 1rem;
  font-size: 0.6rem;
}
.promotion-box .box-txt dl {
  position: relative;
}
.promotion-box .box-txt dt {
  position: absolute;
  left: 0;
  top: 0;
}
.promotion-box .box-txt dd {
  padding-left: 0.75rem;
}
.promotion-box .box-txt p {
  padding-top: 0.5rem;
  padding-bottom: 0.75rem;
  text-align: center;
}
.promotion-box img {
  vertical-align: top;
}
.promotion-box .mr10 {
  margin-right: 0.25rem;
}
.promotion-box .font62 {
  font-size: 1.55rem;
}
.promotion-box .font36 {
  font-size: 0.9rem;
}
.promotion-box .box-con .price-customize {
  position: absolute;
  /* z-index: 1; */
  top: 15rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  background: url(https://dealer2.autoimg.cn/dealerdfs/g26/M0B/23/4F/autohomedealer__ChcCP1tVkhKAa8uTAAAivb2nLhA998.png)
    center center no-repeat;
  background-size: 100% 100%;
  width: 9.275rem;
  height: 5.725rem;
}
.promotion-box .box-con .price-customize-num {
  font-weight: bold;
  color: #f23b3f;
  height: 2.8rem;
  line-height: 2.8rem;
}
.promotion-box .box-con .price-customize-name {
  color: #fff;
  padding-top: 1.2rem;
  line-height: 1;
}
.promotion-box .tit-customize {
  position: absolute;
  top: 1.5rem;
  left: 0;
  z-index: 1;
  right: 0;
  margin: 0 auto;
  width: 13.125rem;
}

.promotion-box .box-con .btn-customize {
  position: absolute;
  top: 22rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  /* z-index: 1; */
  width: 10.275rem;
  height: 1.5rem;
  line-height: 1.5rem;
  border-bottom: 0.25rem solid #ab2125;
  background-color: #e43b40;
  color: #fff;
  text-align: center;
  border-radius: 1.25rem;
  font-size: 0.8rem;
}
.promotion-box div {
  display: block;
}
.promotion-box .box-con .txt-customize {
  font-size: 0.9rem;
  color: #e43b40;
  position: absolute;
  z-index: 1;
  top: 17.5rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  line-height: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/redpacket/index.vue